import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installConsoleCapture } from "@/lib/consoleBuffer";
import { injectThemeStyles, applyTheme, getStoredTheme } from "@/lib/theme";

// Capture console.error calls into an in-memory ring buffer so they can be
// attached to bug reports. Install before React mounts so we don't miss
// any boot-time errors.
installConsoleCapture();

// Inject the global design tokens and apply the saved theme before React
// mounts, so var(--*) resolves on the very first paint (no flash of dark).
injectThemeStyles();
applyTheme(getStoredTheme());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
